import {
    Component,
    EventEmitter,
    Input,
    Optional,
    Output,
} from '@angular/core';
import { CmpsDialogRef } from '@cmps/ng-uikit';

import {
    CmpsPopulationCompareGroupData,
    CmpsPopulationCompareResult,
    CmpsPopulationCompareSubgroupData,
} from './population-compare.metadata';

@Component({
    selector: 'cmps-population-compare',
    template: `
        <div class="cmps-population-compare--container">
            <div class="cmps-population-compare--header">
                <h4 class="cmps-population-compare--title">
                    {{ populationCompareTitle }}
                </h4>
                <button
                    class="cmps-population-compare--close"
                    cmpsIconButton
                    (click)="_dialogRef?.close()"
                >
                    <cmps-icon
                        class="cmps-population-compare--close-button"
                        svgIcon="__internal:close"
                    ></cmps-icon>
                </button>
            </div>

            <div class="cmps-population-compare--select-group-container">
                <div class="cmps-population-compare--select-group">
                    <label
                        class="cmps-population-compare--select-group-label"
                        >{{ selectGroupLabel }}</label
                    >
                    <select
                        class="cmps-population-compare--select"
                        [ngModel]="groupData"
                        (ngModelChange)="_isClicked($event)"
                    >
                        <ng-container *ngFor="let item of groupData">
                            <option [ngValue]="item">
                                {{ item.groupValue }}
                            </option>
                        </ng-container>
                    </select>
                    <cmps-icon
                        class="cmps-population-compare--chevron-down"
                        svgIcon="__internal:chevron-down"
                    ></cmps-icon>
                </div>
            </div>

            <div
                [class.cmps-population-compare--subgroup-container]="
                    isClicked === false
                "
                [class.cmps-population-compare--is-clicked]="isClicked === true"
            >
                <div class="cmps-population-compare--select-subgroup">
                    <label
                        class="cmps-population-compare--select-group-label"
                        >{{ selectSubgroupLabel }}</label
                    >
                    <input
                        type="text"
                        class="cmps-population-compare--search"
                        placeholder="{{ searchLabel }}"
                        [(ngModel)]="_searchText"
                    />
                    <div class="cmps-population-compare--max-height">
                        <ng-container
                            *ngFor="
                                let i of _selectedGroup?.subgroup
                                    | searchFilter: _searchText
                            "
                        >
                            <div
                                class="cmps-population-compare--subgroup-items"
                            >
                                <label
                                    class="cmps-population-compare--checkbox"
                                >
                                    <input
                                        type="checkbox"
                                        cmpsCheckbox
                                        [checked]="i.isSelected"
                                        (click)="_isChecked(i)"
                                    />
                                    {{ i.subgroupValue }}
                                </label>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div class="cmps-population-compare--subgroups">
                    <label
                        class="cmps-population-compare--select-group-label"
                        >{{ groupsToCompareLabel }}</label
                    >
                    <div
                        class="cmps-population-compare--subgroup-checkbox"
                        *ngIf="isChecked === true"
                    >
                        <ng-container
                            *ngFor="let items of _selectedGroup?.subgroup"
                        >
                            <ng-container *ngIf="items.isSelected === true">
                                <label
                                    class="cmps-population-compare--checkbox-label"
                                    (click)="_isChecked(items)"
                                >
                                    <button
                                        class="cmps-population-compare--close-checkbox"
                                        cmpsIconButton
                                    >
                                        <cmps-icon
                                            class="cmps-population-compare--close-button"
                                            svgIcon="__internal:close"
                                        ></cmps-icon>
                                    </button>
                                    {{ items.subgroupValue }}
                                </label>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>

            <div class="cmps-population-compare--compare">
                <button
                    class="cmps-population-compare--reset-btn"
                    cmpsButton
                    (click)="_isReset()"
                >
                    <span cmpsButtonLabel>{{ resetLabel }}</span>
                </button>
                <button
                    cmpsButton
                    (click)="_isCompare()"
                >
                    <span cmpsButtonLabel>{{ compareLabel }}</span>
                </button>
            </div>
        </div>
    `,
    host: {
        class: 'cmps-population-compare',
    },
})
export class CmpsPopulationCompareComponent {
    @Input() populationCompareTitle: string;
    @Input() selectGroupLabel: string;
    @Input() resetLabel: string;
    @Input() compareLabel: string;
    @Input() selectSubgroupLabel: string;
    @Input() subgroupLabel: string;
    @Input() searchLabel: string;
    @Input() groupsToCompareLabel: string;
    @Input() isClicked: boolean = false;
    @Input() isChecked: boolean = false;

    @Input() groupData: CmpsPopulationCompareGroupData[];

    @Output() compareAction: EventEmitter<CmpsPopulationCompareResult>;
    @Output() resetAction: EventEmitter<any>;

    /** @private */ _searchText = '';
    /** @private */ _selectedGroup: CmpsPopulationCompareGroupData;
    /** @private */ _compareData: CmpsPopulationCompareResult;

    constructor(
        /** @private */ @Optional()
        public readonly _dialogRef: CmpsDialogRef<any, any>,
    ) {
        this.compareAction = new EventEmitter();
        this.resetAction = new EventEmitter();
        this._compareData = {};
    }

    ngOnDestroy(): void {
        this.compareAction.complete();
        this.resetAction.complete();
    }

    _isClicked(selectedGroupData: CmpsPopulationCompareGroupData): void {
        this.isClicked = true;
        this._selectedGroup = selectedGroupData;
    }

    _isChecked(selectedCheckBox: CmpsPopulationCompareSubgroupData): void {
        this.isChecked = true;
        this._selectedGroup?.subgroup.forEach((i) => {
            if (i.id === selectedCheckBox.id) {
                i.isSelected = !i.isSelected;
            }
        });
        this._compareData[this._selectedGroup.id] = this._selectedGroup.subgroup
            ?.filter((e) => e.isSelected)
            ?.map((g) => {
                return g.id;
            });
    }

    _isReset(): void {
        this._selectedGroup = {
            groupValue: '',
            id: 0,
            subgroup: [],
        };
    }

    _isCompare(): void {
        this.compareAction.emit(this._compareData);
    }
}
